import { render } from "./Referidos.vue?vue&type=template&id=01e2d03e&scoped=true&ts=true"
import script from "./Referidos.vue?vue&type=script&lang=ts"
export * from "./Referidos.vue?vue&type=script&lang=ts"

import "./Referidos.vue?vue&type=style&index=0&id=01e2d03e&scoped=true&lang=css"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e2d03e"]])

export default __exports__